module.exports = __webpack_public_path__ + "img/new.1dd66c28.svg";